export default __webpack_public_path__ + "static/media/couple-heart.cfeecb53.png";